<span class="aum-panel-infomation-i aumico-pattern-icon-info-accordion">
    <!-- Information icon -->
    <i></i>
    <div #informationWrapper *ngIf="showInformation | async">
        <ng-content></ng-content>
    </div>
</span>
